import React, { useEffect, useContext, useState, useRef, Fragment } from "react";
import { Storage } from "aws-amplify";
import { OffLineAPI } from "../../offline-auth/api";
import { deleteProfilePic, updatProfilePic } from "../../actions/users";
import { PayLoadCtx, LangCtx } from "../../lib/context";
import { getExperience } from "../../lib/functions";
import Loader from "../../lib/ui/loader/Loader";
import "../../ui-styles/list/EditProfileImage.css";
import "../../ui-styles/bottomSlider/BottomDetailsSlide.css";
import { toast } from "react-toastify";

import "../../ui-styles/cropper/imagecrop.css";
import "../../ui-styles/bottomSlider/BottomDetailsSlide.css";

import Demo from "../common/imagecropper/easycropper";
// import { getDegree, getDepartmentList, getSpecialization } from "../../actions/configuration";
import { scan } from "../../actions/appointment";
import Rating from '@material-ui/lab/Rating';
import { capitalize } from "@material-ui/core";

const ProfileImage = (props) => {
    const wrapperRef = useRef();
    const { userDetails, userRole } = props;
    const [filtList, setFiltList] = useState(false);
    const [loading, setLoading] = useState(false);
    const { getPayLoad, payload } = useContext(PayLoadCtx);
    const { l } = useContext(LangCtx);
    const [openCrop, setOpenCrop] = useState(false);
    const [imageToCrop, setImageToCrop] = useState(undefined);
    // const [selectedFile, setSelectedFile] = useState(null);
    const [fname, setFname] = useState("");

    const cancelCrop = () => {
        setOpenCrop(false);
        setImageToCrop(undefined);
        // setSelectedFile(null);
    };

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, false);
        return () => {
            document.removeEventListener("click", handleClickOutside, false);
        };
    }, []);

    const handleCroppedUpload = async (file) => {
        let filename = fname; //new Date().valueOf() + file.name;
        //filename = "doctor" + target + "/" + filename;
        //let target = trtgt //"signature"
        try {
            const fileUploadResBody = await uploadOnlineOrOffline(filename, file);
            const updateProfilePicRes = await updatProfilePic(fileUploadResBody);
            if (updateProfilePicRes.status) {
                setLoading(false);
                getPayLoad();
            }
        } catch (err) {
            setLoading(false);
            toast.error("Profile update failed due to the presence of viruses.");
            setTimeout(() => {
                window.location.reload();
            }, 5000);
        }
    };

    const handleClickOutside = (event) => {
        // if (wrapperRef && !wrapperRef.current.contains(event.target)) {
        //     setFiltList(false);
        // }
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setFiltList(false);
        }
    };

    const handleEditImage = () => {
        setFiltList((prevState) => !prevState);
    };
    // const closeImageCrop = () => {
    //     setImageToCrop(null);
    //     setSelectedFile(null);
    // };
    // const updateImageCrop = async (e) => {
    //     if (e.target.files.length > 0) {
    //         const acceptedTypes = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];
    //         setLoading(true);
    //         let file = e.target.files[0];
    //         let filename = new Date().valueOf() + file.name;
    //         if (file && acceptedTypes.includes(file["type"]) && file.size / (1024 * 1024) < 10) {
    //             // code for aws s3 bucket
    //             // Storage.configure({ region: process.env.REACT_APP_profileRegion, bucket: process.env.REACT_APP_profileBucket });
    //             const formData = new FormData();
    //             formData.append("file", file);

    //             let params = {
    //                 bucket: process.env.REACT_APP_profileBucket,
    //                 fileName: `public/${filename}`,
    //                 region: process.env.REACT_APP_profileRegion,
    //             };

    //             let s3UploadRes = await scan(formData, params);

    //             console.log("s3UploadRes", s3UploadRes);
    //             if (s3UploadRes && s3UploadRes.status) {
    //                 s3UploadRes = s3UploadRes.data;
    //                 const body = {
    //                     url: `https://${process.env.REACT_APP_profileBucket}.s3-${process.env.REACT_APP_profileRegion}.amazonaws.com/${s3UploadRes.key}`,
    //                     key: s3UploadRes.key,
    //                 };
    //                 updatProfilePic(body)
    //                     .then((res) => {
    //                         setLoading(false);
    //                         if (res.status) {
    //                             getPayLoad();
    //                         }
    //                     })
    //                     .catch((err) => {
    //                         setLoading(false);
    //                         toast.error(err.errorMessage, {
    //                             position: toast.POSITION.TOP_RIGHT,
    //                         });
    //                     });
    //             } else {
    //                 toast.error(s3UploadRes.error, {
    //                     position: toast.POSITION.TOP_RIGHT,
    //                 });
    //             }
    //             setLoading(false);

    //             // Storage.put(filename, file, { contentType: file.type })
    //             //     .then((result) => {
    //             //         const body = {
    //             //             url: "https://instavcprofileimages.s3.ap-south-1.amazonaws.com/public/" + result.key,
    //             //             key: result.key,
    //             //         };
    //             //         updatProfilePic(body)
    //             //             .then((res) => {
    //             //                 setLoading(false);
    //             //                 if (res.status) {
    //             //                     getPayLoad();
    //             //                 }
    //             //             })
    //             //             .catch((err) => {
    //             //                 setLoading(false);
    //             //                 toast.error(err.errorMessage, {
    //             //                     position: toast.POSITION.TOP_RIGHT,
    //             //                 });
    //             //             });
    //             //         // const formData = new FormData();
    //             //         // formData.append('fileData', file);
    //             //         // OffLineAPI.upload("api", "/savefile", formData)
    //             //         //     .then(res => {
    //             //         //         // console.log("res === ", res);
    //             //         //         // resolve(res);
    //             //         //         const body = {
    //             //         //             url: config.api_server + '/api/uploads/profile/'+ res.path,
    //             //         //             // url: '/api/uploads/profileImages' + filename + res.path,
    //             //         //             key: res.path,
    //             //         //         }

    //             //         //     }).catch(err => {
    //             //         //         toast.error(err.errorMessage, {
    //             //         //             position: toast.POSITION.TOP_RIGHT
    //             //         //         })
    //             //         //     });
    //             //     })
    //             //     .catch((error) => {
    //             //         setLoading(false);
    //             //         console.log("error ==== ", error);
    //             //     });
    //         } else {
    //             toast.error("File size should be below 10MB", {
    //                 position: toast.POSITION.TOP_RIGHT,
    //             });
    //         }
    //     }
    // };

    /**
     * @param {string} fileName - name of the file
     * @param {Object} file - file to upload
     */
    const uploadOnlineOrOffline = (fileName, file) => {
        setLoading(true);
        return new Promise(async (resolve, reject) => {
            let body = {};
            if (process.env.REACT_APP_isOffline === "true") {
                //upload to server folder
                const formData = new FormData();
                formData.append("fileData", file);
                try {
                    const offlineUploadRes = await OffLineAPI.upload("api", "/savefile", formData);
                    body = {
                        url: `${process.env.REACT_APP_api_server}/api/uploads/profile/${offlineUploadRes.path}`,
                        key: offlineUploadRes.path,
                    };
                } catch (error) {
                    setLoading(false);
                    return reject(error);
                }
            } else {
                //upload to s3 bucket
                try {
                    // Storage.configure({
                    //     region: process.env.REACT_APP_profileRegion,
                    //     bucket: process.env.REACT_APP_profileBucket,
                    // });
                    // const s3UploadRes = await Storage.put(fileName, file, { contentType: file.type });
                    // console.log("s3UploadRes", s3UploadRes);
                    // body = {
                    //     url: "https://instavcprofileimages.s3.ap-south-1.amazonaws.com/public/" + s3UploadRes.key,
                    //     key: s3UploadRes.key,
                    // };

                    const formData = new FormData();
                    formData.append("file", file);

                    let params = {
                        bucket: process.env.REACT_APP_profileBucket,
                        fileName: `public/${fileName}`,
                        region: process.env.REACT_APP_profileRegion,
                    };

                    let s3UploadRes = await scan(formData, params);

                    if (s3UploadRes && s3UploadRes.status) {
                        s3UploadRes = s3UploadRes.data;
                        body = {
                            url: `https://${process.env.REACT_APP_profileBucket}.s3-${process.env.REACT_APP_profileRegion}.amazonaws.com/${s3UploadRes.Key}`,
                            key: s3UploadRes.Key,
                        };
                    } else {
                        setLoading(false);
                        toast.error(s3UploadRes.error, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        return resolve({});
                    }
                } catch (error) {
                    setLoading(false);
                    return reject(error);
                }
            }
            return resolve(body);
        });
    };

    const handleUploadProfilePic = async (e) => {
        // setOpenCrop(prevState => !prevState);

        if (e.target.files && e.target.files.length > 0) {
            //const acceptedTypes = ["image/jpeg", "image/jpg", "image/png"];
            let file = e.target.files[0];

            let reader = new FileReader();
            reader.readAsDataURL(file);

            // setSelectedFile(file);

            reader.onloadend = (i) => {
                var _img = new Image();

                //Set the Base64 string return from FileReader as source.
                _img.src = i.target.result;

                _img.onload = async () => {

                    setLoading(false);
                    setImageToCrop(_img);
                };
            };

            setOpenCrop(1);
            if (file) {
                if (file) {
                    // const reader = new FileReader();
                    // reader.addEventListener("load", () => {
                    //     const image = reader.result;
                    //     if (image.width > 595 && image.height > 100) {
                    //         setLoading(false);
                    //         toast.error("Please upload image with dimensions mentioned.", {
                    //             position: toast.POSITION.TOP_RIGHT
                    //         })
                    //         return;
                    //     }
                    //     setImageToCrop(image);
                    // });

                    // reader.readAsDataURL(e.target.files[0]);
                    setLoading(true);
                    //handle offline or online file upload
                    let filename = new Date().valueOf() + file.name;

                    setFname(filename);

                    setLoading(false);
                    // try {
                    //     const fileUploadResBody = await uploadOnlineOrOffline(filename, file);
                    //     const updateProfilePicRes = await updatProfilePic(fileUploadResBody);
                    //     if (updateProfilePicRes.status) {
                    //         setLoading(false);
                    //         getPayLoad();
                    //     }
                    // } catch (err) {
                    //     setLoading(false);
                    //     toast.error(err.errorMessage, {
                    //         position: toast.POSITION.TOP_RIGHT,
                    //     });
                    // }

                    // Storage.configure({
                    //     region: "ap-south-1",
                    //     bucket: "instavcprofileimages",
                    // });
                    // Storage.put(filename, file, { contentType: file.type })
                    //     .then((result) => {
                    //         const body = {
                    //             url: "https://instavcprofileimages.s3.ap-south-1.amazonaws.com/public/" + result.key,
                    //             key: result.key,
                    //         };
                    //         updatProfilePic(body)
                    //             .then((res) => {
                    //                 setLoading(false);
                    //                 if (res.status) {
                    //                     getPayLoad();
                    //                 }
                    //             })
                    //             .catch((err) => {});
                    //         // const formData = new FormData();
                    //         // formData.append('fileData', file);
                    //         // OffLineAPI.upload("api", "/savefile", formData)
                    //         //     .then(res => {
                    //         //         // console.log("res === ", res);
                    //         //         // resolve(res);
                    //         //         const body = {
                    //         //             url: process.env.REACT_APP_api_server + '/api/uploads/profile/'+ res.path,
                    //         //             // url: '/api/uploads/profileImages' + filename + res.path,
                    //         //             key: res.path,
                    //         //         }

                    //         //     }).catch(err => {
                    //         //         toast.error(err.errorMessage, {
                    //         //             position: toast.POSITION.TOP_RIGHT
                    //         //         })
                    //         //     });
                    //     })
                    //     .catch((error) => {
                    //         setLoading(false);
                    //         console.log("error ==== ", error);
                    //     });
                } else {
                    toast.success("Please upload file size should be below 10MB", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
            } else {
                toast.success("Please upload files in format of PNG, JPG and JPEG only.", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        }
    };

    // const handleStore = async (croppedImage) => {
    //     setLoading(true);
    //     // Storage.configure({ region: process.env.REACT_APP_profileRegion, bucket: process.env.REACT_APP_profileBucket });
    //     let filename = new Date().valueOf() + selectedFile.name;
    //     // Storage.put(filename, croppedImage, { contentType: selectedFile.type })
    //     //     .then((result) => {
    //     //         const body = {
    //     //             url: "https://instavcprofileimages.s3.ap-south-1.amazonaws.com/public/" + result.key,
    //     //             key: result.key,
    //     //         };
    //     //         updatProfilePic(body)
    //     //             .then((res) => {
    //     //                 setLoading(false);
    //     //                 if (res.status) {
    //     //                     getPayLoad();
    //     //                 }
    //     //             })
    //     //             .catch((err) => {
    //     //                 setLoading(false);
    //     //                 toast.error(err.errorMessage, {
    //     //                     position: toast.POSITION.TOP_RIGHT,
    //     //                 });
    //     //             });
    //     //         // const formData = new FormData();
    //     //         // formData.append('fileData', file);
    //     //         // OffLineAPI.upload("api", "/savefile", formData)
    //     //         //     .then(res => {
    //     //         //         // console.log("res === ", res);
    //     //         //         // resolve(res);
    //     //         //         const body = {
    //     //         //             url: config.api_server + '/api/uploads/profile/'+ res.path,
    //     //         //             // url: '/api/uploads/profileImages' + filename + res.path,
    //     //         //             key: res.path,
    //     //         //         }

    //     //         //     }).catch(err => {
    //     //         //         toast.error(err.errorMessage, {
    //     //         //             position: toast.POSITION.TOP_RIGHT
    //     //         //         })
    //     //         //     });
    //     //     })
    //     //     .catch((error) => {
    //     //         setLoading(false);
    //     //         console.log("error ==== ", error);
    //     //     });

    //     const formData = new FormData();
    //     formData.append("file", croppedImage);

    //     let params = {
    //         bucket: process.env.REACT_APP_profileBucket,
    //         fileName: `public/${filename}`,
    //         region: process.env.REACT_APP_profileRegion,
    //     };

    //     let s3UploadRes = await scan(formData, params);

    //     console.log("s3UploadRes", s3UploadRes);
    //     if (s3UploadRes && s3UploadRes.status) {
    //         s3UploadRes = s3UploadRes.data;
    //         const body = {
    //             url: `https://${process.env.REACT_APP_profileBucket}.s3-${process.env.REACT_APP_profileRegion}.amazonaws.com/${s3UploadRes.key}`,
    //             key: s3UploadRes.key,
    //         };

    //         updatProfilePic(body)
    //             .then((res) => {
    //                 setLoading(false);
    //                 if (res.status) {
    //                     getPayLoad();
    //                 }
    //             })
    //             .catch((err) => {
    //                 setLoading(false);
    //                 toast.error(err.errorMessage, {
    //                     position: toast.POSITION.TOP_RIGHT,
    //                 });
    //             });
    //     } else {
    //         toast.error(s3UploadRes.error, {
    //             position: toast.POSITION.TOP_RIGHT,
    //         });
    //     }
    //     setLoading(false);
    // };
    // {
    //     /*
    //     if (e.target.files.length > 0) {
    //         const acceptedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
    //         setLoading(true);
    //         let file = e.target.files[0];
    //         let filename = new Date().valueOf() + file.name;
    //         if (file && acceptedTypes.includes(file['type']) && file.size / (1024 * 1024) < 10) {
    //             // code for aws s3 bucket
    //             Storage.configure({ region: 'ap-south-1', bucket: 'instavcprofileimages' })

    //             Storage.put(filename,
    //                 file,
    //                 { contentType: file.type })
    //                 .then(result => {
    //                     const body = {
    //                         url: 'https://instavcprofileimages.s3.ap-south-1.amazonaws.com/public/' + result.key,
    //                         key: result.key,
    //                     }
    //                     updatProfilePic(body).then(res => {
    //                         setLoading(false);
    //                         if (res.status) {
    //                             getPayLoad()
    //                         }
    //                     }).catch(err => {
    //                         setLoading(false);
    //                         toast.error(err.errorMessage, {
    //                             position: toast.POSITION.TOP_RIGHT
    //                         })
    //                     })
    //                     // const formData = new FormData();
    //                     // formData.append('fileData', file);
    //                     // OffLineAPI.upload("api", "/savefile", formData)
    //                     //     .then(res => {
    //                     //         // console.log("res === ", res);
    //                     //         // resolve(res);
    //                     //         const body = {
    //                     //             url: config.api_server + '/api/uploads/profile/'+ res.path,
    //                     //             // url: '/api/uploads/profileImages' + filename + res.path,
    //                     //             key: res.path,
    //                     //         }

    //                     //     }).catch(err => {
    //                     //         toast.error(err.errorMessage, {
    //                     //             position: toast.POSITION.TOP_RIGHT
    //                     //         })
    //                     //     });
    //                 }).catch(error => {
    //                     setLoading(false);
    //                     console.log("error ==== ", error);
    //                 })
    //         }
    //         else {
    //             toast.success("Please upload files in format of PNG, JPG, JPEG and PDF only. And size should be below 10MB", {
    //                 position: toast.POSITION.TOP_RIGHT
    //             })
    //         }

    //     }

    // }*/
    // }

    const deleteProfile = async () => {
        setLoading(true);
        let body = {
            sub: payload.userId,
        };
        try {
            const deleteProfilePicRes = await deleteProfilePic(body);
            getPayLoad();
            setLoading(false);
            if (deleteProfilePicRes.status) {
                if (process.env.REACT_APP_isOffline === "true") {
                    await OffLineAPI.uploadDelete("api", "/deletewaitingroomfile", { body: { ...userDetails.profileImage } });
                } else {
                    await Storage.remove(userDetails.profileImage.key);
                }
            }
        } catch (error) {
            setLoading(false);
            setFiltList(false);
            console.log("error ==== ", error);
        }
    };

    return (
        <div className={` vrtclProfileBox ${props.certfyStyle} `}>
            {userDetails ? (
                <Fragment>
                    <div className="vrtclPAvtr Lg" ref={wrapperRef}>
                    {loading && <Loader />}

                        {userDetails.profileImage ? (
                            <img src={userDetails.profileImage.url} alt="avatar" />
                        ) : (
                            // <img
                            //     src={
                            //         userRole === "D" || userRole === "C"
                            //             ? "/images/icons/doctor-default.png"
                            //             : "/images/icons/patient-default.png"
                            //     }
                            //     alt="avatar"
                            // />
                            <img
                                src={
                                    userRole === "D"
                                        ? "/images/icons/doctor-default.png"
                                        : userRole === "C"
                                        ? "/images/icons/default-clinic.png"
                                        : "/images/icons/patient-default.png"
                                }
                                alt="avatar"
                            />
                        )}
                        {userDetails?.profileImage?.url &&
                        userDetails.profileImage.url !==
                            "https://insta-consult.s3.ap-southeast-1.amazonaws.com/defaultImage/default-user.png" ? (
                            <div className="editProfleBtn" onClick={handleEditImage}>
                                <img src="/images/icons/draw.png" className="invertWhite" alt="icon" />
                            </div>
                        ) : (
                            <div className="editProfleBtn" onClick={handleUploadProfilePic}>
                                <input className="editListItemInput" type="file" accept="image/*" name="uploadPic" onChange={handleUploadProfilePic} />
                                <img src="/images/icons/camera-filled.png" className="invertWhite" alt="icon" />
                            </div>
                        )}
                        {filtList && (
                           <div className="editProfileImgBox">
                           <ul className="editListGroup">
                               <li className="editListItem" onClick={() => document.getElementById("fileInput").click()}>
                                   {/* Hidden input */}
                                   <input
                                       id="fileInput"
                                       className="editListItemInput"
                                       type="file"
                                       accept="image/*"
                                       name="uploadPic"
                                       style={{ display: "none" }}  // Hide the input
                                       onChange={handleUploadProfilePic}
                                   />
                                   {/* Custom trigger */}
                                   <div className="editListAvtr Sm">
                                       <img src="/images/icons/camera-filled.png" className="invertGray" alt="icon" />
                                   </div>
                                   <div className="editListContent">
                                       <span className="editlistTxtL">{l.change_picture}</span>
                                   </div>
                               </li>
                               <li className="editListItem" onClick={deleteProfile}>
                                   <div className="editListAvtr Sm">
                                       <img src="/images/icons/delete-outline.png" className="invertGray" alt="icon" />
                                   </div>
                                   <div className="editListContent">
                                       <span className="editlistTxtL">{l.delete}</span>
                                   </div>
                               </li>
                           </ul>
                       </div>
                       
                        )}
                        {/* <img src="/images/icons/camera-filled.png" className="invertWhite" alt="icon" />
                <input type="file" name="uploadPic" onChange={handleUploadProfilePic} /> */}
                    </div>
                    {userRole === "D" ? (
                        <>
                        <div className="vrticlTitleCol txtCenter">
                        <span className="vrtclAvtrTxtS"><Rating name="read-only" precision={0.1} value={userDetails.ratings?.stars || 0} readOnly /></span>

                            
                            <span className="vrtclAvtrTxtL txtAlignEnd">
                            {userDetails.title ? userDetails.title : ""}
                                {userDetails.firstName ? userDetails.firstName : ""}{" "}
                                {userDetails.lastName ? " " + userDetails.lastName : ""}
                            </span>
                            <span className="vrtclAvtrTxtS">
                                {userDetails.qualification ? userDetails.qualification : ""}
                                {userDetails.department ? `(${userDetails.department})` : ""}
                                {userDetails.serviceStartDate ? `- ${getExperience(new Date(userDetails.serviceStartDate))}` : ""}
                            </span>
                            <span className="vrtclAvtrTxtS">{userDetails.speciality ? `(${userDetails.speciality})` : ""}</span>
                            {/* <span className="vrtclAvtrTxtS" style={{ color: '#EFBE0F' }}>{userDetails.status}</span>
                             */}
                             <span
                                    className="vrtclAvtrTxtS"
                                    style={{
                                        color: userDetails.status === "approved" ? "green" : userDetails.status === "rejected" ? "red" : "#EFBE0F",text: capitalize
                                    }}
                                >
                                {userDetails?.status?.charAt(0).toUpperCase() + userDetails?.status?.slice(1)}          
                       </span>

                            <span className="vrtclAvtrTxtS"style={{padding: '0 4px'}}>{userDetails.summary}</span>
                        </div>
                        {/* <div className="flexCol " style={{padding:'10px'}} > */}
                                {/* <span  style={{ alignItems: 'flex-start' }}>Description</span> */}
                                {/* <span className="vrtclAvtrTxtS">{userDetails.summary}</span> */}
                            {/* </div> */}
                            </>


                       
                    ) : userRole === "C" ? (
                        <div className="vrticlTitleCol txtCenter">
                            <span className="vrtclAvtrTxtL">{userDetails.clinicName}</span>
                            {/*<span className="vrtclAvtrTxtS">CLC07658</span>*/}
                        </div>
                    ) : userRole === "P" ? (
                        <div className="vrticlTitleCol txtCenter">
                            <span className="vrtclAvtrTxtL">
                                {userDetails.title ? userDetails.title : ""}
                                {userDetails.firstName ? userDetails.firstName : ""}
                                {userDetails.lastName ? " " + userDetails.lastName : ""}
                            </span>
                            <span className="vrtclAvtrTxtS capitalizeTxt">{userDetails.gender ? userDetails.gender : ""}</span>
                        </div>
                    ) : (
                        <div className="vrticlTitleCol txtCenter">
                            <span className="vrtclAvtrTxtL">{userDetails.firstName ? userDetails.firstName : ""}</span>
                            <span className="vrtclAvtrTxtS capitalizeTxt">{userDetails.gender ? userDetails.gender : ""}</span>
                        </div>
                    )}
                </Fragment>
            ) : null}

            {/* Cropping image popup */}
            {imageToCrop && openCrop && (
                <div className={imageToCrop ? "btmDtlSlider visible" : "btmDtlSlider"}>
                    <div className="cropperPaper">
                        <Demo
                            cancelCrop={cancelCrop}
                            target={"profile"}
                            cropRatio={1}
                            imageToCrop={imageToCrop.src}
                            onImageCropped={(croppedImage) => handleCroppedUpload(croppedImage)}
                        ></Demo>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProfileImage;
